/**
 * Date/time formatters for the subcontractor portal. Every stamp renders in the
 * PROJECT's timezone — a subcontractor reads these against the site's working
 * day, not the viewer's clock. Formatters are built per call rather than
 * hoisted, since the zone is now an argument.
 */
function jpDate(tz: string) {
  return new Intl.DateTimeFormat('ja-JP', { timeZone: tz, month: 'short', day: 'numeric' });
}

function jpDateFull(tz: string) {
  return new Intl.DateTimeFormat('ja-JP', {
    timeZone: tz,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

function jpTime(tz: string) {
  return new Intl.DateTimeFormat('ja-JP', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function formatShortDate(iso: string, tz: string): string {
  return jpDate(tz).format(new Date(iso));
}

export function formatFullDate(iso: string, tz: string): string {
  return jpDateFull(tz).format(new Date(iso));
}

export function formatTime(iso: string, tz: string): string {
  return jpTime(tz).format(new Date(iso));
}

export function formatRelative(iso: string, tz: string, now: Date = new Date()): string {
  const diffMs = now.getTime() - new Date(iso).getTime();
  const diffMin = Math.round(diffMs / 60_000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 7) return `${diffDay}d ago`;
  // Past the relative window the absolute date takes over — same project zone.
  return formatShortDate(iso, tz);
}
